const House = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='128'
    height='235'
    viewBox='0 0 128 235'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 85h128v128H0V85Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m18.533 145.786 5.365 88.358 91.48-5.554-5.148-84.801-2.133-3.441-89.564 5.438Z'
      fill='#949494'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M104.48 49.11a.08.08 0 0 0-.026-.052.077.077 0 0 0-.054-.019l-13.363.81-.852-14.013-9.995.607.852 14.014-67.97 4.127a.077.077 0 0 0-.071.082l2.94 48.44 91.48-5.555-2.94-48.44-.001-.001Z'
      fill='#70210D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m23.898 234.144 29.92-1.817-5.517-90.876-26.843 2.771-2.709 5.12 5.149 84.802Z'
      fill='#91C5F0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m39.324 207.494-3.464.21-1.584-26.081 3.464-.21 1.584 26.081Z'
      fill='#CF8640'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M37.47 173.047c4.268-1.196 7.229-5.341 6.707-9.981-.533-4.735-4.658-8.334-9.42-8.227-5.291.119-9.378 4.604-9.06 9.839.27 4.44 3.62 7.96 7.847 8.607a9.282 9.282 0 0 0-6.706 9.982c.532 4.733 4.657 8.334 9.419 8.226a9.277 9.277 0 0 0 9.06-9.84c-.268-4.44-3.62-7.96-7.846-8.606'
      fill='#006837'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M96.858 161.396a4.267 4.267 0 0 0-4.52-4l-24.053 1.46a4.267 4.267 0 0 0-4.002 4.518l3.263 53.957 32.53-1.976-3.218-53.959Z'
      fill='#FFEDD7'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M82.986.016c5.986-.363 10.562 5.254 8.995 11.042l-1.806 6.666-4.994 18.448-7.191-17.708-2.597-6.4C73.138 6.509 77 .379 82.984.016h.002Z'
      fill='#FFAF84'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M107.422 97.551 59.071 57.337l-43.13 45.769 2.808 46.237 91.481-5.555-2.808-46.237Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m43.745 139.046-9.61.583-1.687-27.781 9.61-.583 1.687 27.781Zm12.755-.775-9.61.583-1.687-27.781 9.61-.583 1.687 27.781ZM31.913 108.93c-.382-6.296 4.411-11.709 10.706-12.09 6.295-.383 11.71 4.41 12.091 10.706l-22.797 1.384ZM81.4 136.759l-9.609.584-1.687-27.782 9.609-.583 1.687 27.781Zm12.756-.774-9.61.583-1.687-27.781 9.61-.583 1.687 27.781Zm-24.587-29.342c-.382-6.295 4.41-11.708 10.706-12.09 6.296-.383 11.709 4.41 12.09 10.706l-22.796 1.384Z'
      fill='#FFF4E9'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M95.28 188.528a3.077 3.077 0 0 1-5.851 1.549 3.07 3.07 0 0 1-.293-1.176 3.077 3.077 0 1 1 6.145-.373'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m114.49 213.926-69.407 4.215.808-19.2a.592.592 0 0 0-.631-.62l-16.595 1.009a.603.603 0 0 0-.43.223.595.595 0 0 0-.122.469l3.127 18.96-8.143.495.892 14.663 91.39-5.55-.89-14.663.001-.001Z'
      fill='#70210D'
    />
  </svg>
);

export default House;
